import { random, round2Str, formatDateTime } from "../helpers/helpers";

export const generateBmsLineDemo = ({ meter_id, start, end }) => {
    const now = new Date();

    // 🧠 Extract YYYY-MM-DD safely
    const dayStr = start.split(" ")[0];

    const dayStart = new Date(`${dayStr} 00:00:00`);
    const dayEnd = new Date(`${dayStr} 23:59:59`);

    // 🚫 Future day → no data
    if (dayStart.getTime() > now.getTime()) {
        return {
            meter_id: Number(meter_id),
            temperature: [],
            voltage: [],
        };
    }

    // ⛔ Clamp end time if today
    const finalEnd =
        dayEnd.getTime() > now.getTime() ? now : dayEnd;

    const temperature = [];
    const voltage = [];

    let cursor = new Date(dayStart);

    // 🔋 Realistic base values
    let baseTemp = random(26, 29);       // °C
    let baseVoltage = random(13.8, 14.3);
    let baseCurrent = random(0.3, 1.8);

    while (cursor.getTime() <= finalEnd.getTime()) {
        // small natural drift
        baseTemp += random(-0.05, 0.05);
        baseVoltage += random(-0.03, 0.03);
        baseCurrent += random(-0.05, 0.05);

        temperature.push({
            device_time: formatDateTime(cursor),
            temp: round2Str(baseTemp),
        });

        voltage.push({
            device_time: formatDateTime(cursor),
            voltage: round2Str(baseVoltage),
            current: round2Str(Math.max(baseCurrent, 0)),
            percentage: 100,
        });

        // ⏱ 2-minute interval
        cursor = new Date(cursor.getTime() + 2 * 60 * 1000);
    }

    return {
        meter_id: Number(meter_id),
        temperature,
        voltage,
    };
};
